const BSSingle = [
    {id: "0", value: "買進"},    
    {id: "1", value: "賣出"}
  ];  
  
export default BSSingle  